import React from 'react';
import type { FormFieldProps } from 'semantic-ui-react';

import { FormField } from '../FormField/FormField';

import type { CalendarProps } from './RawCalendar';
import { RawCalendar } from './RawCalendar';

const DEFAULT_BACKGROUND_EVENTS_FIELD_NAME = 'BACKGROUND_EVENTS';
const DEFAULT_BACKGROUND_EVENTS: CalendarProps['backgroundEvents'] = [];

export type CalendarFormProps = Omit<CalendarProps, 'events'> & {
  backgroundEventsFieldName?: string;
};

export const createCalendarChangeHandler = ({
  fieldName,
  backgroundEventsFieldName,
  setFieldValue,
}: {
  fieldName: string;
  backgroundEventsFieldName: string | undefined;
  setFieldValue: FormFieldProps['setFieldValue'];
}) => {
  return async (
    data: CalendarProps['events'],
    bgData: CalendarProps['backgroundEvents']
  ) => {
    await setFieldValue(fieldName, data);
    if (backgroundEventsFieldName) {
      await setFieldValue(backgroundEventsFieldName, bgData);
    }
  };
};

export const Calendar = ({
  backgroundEvents = DEFAULT_BACKGROUND_EVENTS,
  backgroundEventsFieldName = DEFAULT_BACKGROUND_EVENTS_FIELD_NAME,
  dayMode,
  displayDate,
  editableEventId,
  height,
  name,
  permissions,
  startMode,
  timezone,
  scrollToTime,
  toolbarLeftSlot,
  weekMode,
}: CalendarFormProps) => {
  return (
    <FormField
      name={name}
      renderField={({ setFieldValue, value }: FormFieldProps) => {
        const handleChange = createCalendarChangeHandler({
          fieldName: name,
          backgroundEventsFieldName,
          setFieldValue,
        });

        return (
          <RawCalendar
            name={name}
            permissions={permissions}
            events={value}
            editableEventId={editableEventId}
            startMode={startMode}
            weekMode={weekMode}
            dayMode={dayMode}
            backgroundEvents={backgroundEvents}
            scrollToTime={scrollToTime}
            timezone={timezone}
            toolbarLeftSlot={toolbarLeftSlot}
            height={height}
            onChange={handleChange}
            displayDate={displayDate}
          />
        );
      }}
    />
  );
};
